import { inject, type InjectionKey } from 'vue'
import type { Client, Stakeholder, Vendor } from '@gat-ship/types'

export interface ShowStakeholderUpdateGeneralInfoParams {
  stakeholder: Stakeholder
}

export interface ShowStakeholderUpdatePostAddressParams {
  stakeholder: Stakeholder
}

export interface ShowStakeholderUpdateVisitAddressParams {
  stakeholder: Stakeholder
}

export interface ShowStakeholderUpdateBillingAddressParams {
  stakeholder: Client
}

export interface ShowStakeholderUpdateBillingDetailsParams {
  stakeholder: Client
}

export interface ShowStakeholderUpdateInternalIdentificationNumbersParams {
  stakeholder: Client | Vendor
}

export interface ShowStakeholderUpdateOfficialBusinessNumbersParams {
  stakeholder: Client | Vendor
}

/**
 * The stakeholder edit-modal opener surface, provided by
 * `StakeholderModalProvider` and injected by the detail groups / sections.
 * Lives in a dedicated module (not `index.ts`) to avoid the
 * provider↔barrel circular dependency.
 */
export interface StakeholderModalsContext {
  showUpdateGeneralInfo: (
    params: ShowStakeholderUpdateGeneralInfoParams
  ) => void
  showUpdatePostAddress: (
    params: ShowStakeholderUpdatePostAddressParams
  ) => void
  showUpdateVisitAddress: (
    params: ShowStakeholderUpdateVisitAddressParams
  ) => void
  showUpdateBillingAddress: (
    params: ShowStakeholderUpdateBillingAddressParams
  ) => void
  showUpdateBillingDetails: (
    params: ShowStakeholderUpdateBillingDetailsParams
  ) => void
  showUpdateInternalIdentificationNumbers: (
    params: ShowStakeholderUpdateInternalIdentificationNumbersParams
  ) => void
  showUpdateOfficialBusinessNumbers: (
    params: ShowStakeholderUpdateOfficialBusinessNumbersParams
  ) => void
}

export const stakeholderModalsKey = Symbol(
  'gs-stakeholder-modals'
) as InjectionKey<StakeholderModalsContext>

/** Inject the stakeholder edit-modal openers provided by `StakeholderModalProvider`. */
export function useStakeholderModals() {
  return inject(stakeholderModalsKey)
}
